import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AddPromotionComponent } from './add-promotion/add-promotion.component';
import { DeletePromotionComponent } from './delete-promotion/delete-promotion.component';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { Promotion } from '../promotion.model';
import { SendSponsoringEmailComponent } from 'src/app/manufacturer/sponsoring/send-sponsoring-email/send-sponsoring-email.component';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-promotions',
    templateUrl: './promotions.component.html',
    styleUrls: ['./promotions.component.scss'],
    standalone: false
})
export class PromotionsComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  selected = 'all';
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  isUsed = null;
  userID: number;
  promotionsList = new Array<Promotion>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    isUsed: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    isUsed: null
  };

  searchValue = "";
  showSelect = false;
  selectedCodes = new Array<any>();

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
              private exportService: ExportService) {
                this.showSearch = false;
                this.userID = this.authService.getUserData().id;
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                    this.pageSize = params.pageSize ? params.pageSize : 10;
                    this.searchValue =  params.searchValue ? params.searchValue : "";
                    this.isUsed = params.isUsed;
                    this.selected = params.isUsed === 'true'  ? 'used'  : 'not-used';
                    if  (params.isUsed === undefined) {
                      this.isUsed = null;
                      this.selected = 'all';
                    }
                  }
                  this.getPromotions();
                });
   }

  ngOnInit(): void {
    this.utils.setTitle('Promotions');
    this.utils.screenTitle.emit({firstTitle: 'Promotions', firstRoute: '/promotions'});
    this.searchForm = new FormGroup({
      sponsorSearch: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('sponsorSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  sendEmails() {
    if (this.selectedCodes.length > 0) {
      const dialogRef = this.dialog.open(SendSponsoringEmailComponent,
        {disableClose: true, width: '400px', data: {codesList: this.selectedCodes}});
      dialogRef.afterClosed().subscribe(() => {
        this.showSelect = false;
      });
    }
  }

  onCheckChange(item: any, checked: boolean) {
    if (checked === true) {
      this.selectedCodes.unshift(item);
    } else {
      const index = this.selectedCodes.indexOf(item);
      this.selectedCodes.splice(index, 1);
    }
  }

  toggleSelect() {
    this.selectedCodes = [];
    this.showSelect = !this.showSelect;
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
    this.router.navigate(['/promotions'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch && this.promotionsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('sponsorSearch')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('sponsorSearch')?.setValue(this.searchValue, { emitEvent: false });

    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
      this.router.navigate(['/promotions'], { queryParams: this.queryParams });
    }
  }

  filterChange(value: any) {
    this.showSelect = false;
    this.selected = value;
    if (value === 'all') {
      this.isUsed = null;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
      this.router.navigate(['/promotions'], { queryParams: this.queryParams });
    } else if (value === 'used') {
      this.isUsed = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
      this.router.navigate(['/promotions'], { queryParams: this.queryParams });
    } else if (value === 'not-used') {
      this.isUsed = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
      this.router.navigate(['/promotions'], { queryParams: this.queryParams });
    }
  }

  openAddPromotion() {
    const dialogRef = this.dialog.open(AddPromotionComponent, {disableClose: true, width: '400px'});
    dialogRef.afterClosed().subscribe((newPromotions) => {
      if (newPromotions.length > 0) {
        this.getPromotions();
      }
    });
  }

  deletePromotion(id: any, code: any) {
    const dialogRef = this.dialog.open(DeletePromotionComponent, {
      disableClose: true,
      width: '400px',
      data: {
      id,
      code
    }});
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'delete') {
        this.promotionsList.forEach( (promotion, index) => {
          if (promotion.id === id) {
            this.promotionsList.splice(index, 1);
            if (this.promotionsList.length === 0 && this.pageNumber > 1){
              this.pageNumber = this.pageNumber - 1;
              this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
              this.router.navigate(['/promotions'], { queryParams: this.queryParams });
            } else {
              this.getPromotions();
            }
          }
        });
      }
    });
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('sponsorSearch')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      isUsed: this.isUsed
    };
    this.router.navigate(['/promotions'], { queryParams: this.queryParams });
  }

  getPromotions() {
    if (this.isUsed ===  null) {
      this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/' +
      parseInt(this.userID.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue).then((data: any) => {
        if (data.statusCode === 200) {
          this.promotionsList = [];
          const promotionsData = data.data.records;
          this.totalSize = data.data.count;
          promotionsData.forEach((promotionData: any) => {
            const promotionInstance = new Promotion(promotionData);
            this.promotionsList.push(promotionInstance);
          });
          if (promotionsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
            this.router.navigate(['/promotions'], { queryParams: this.queryParams });
          }
        }
      });
    } else {
      this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/' +
      parseInt(this.userID.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&isUsed=' + this.isUsed).then((data: any) => {
        if (data.statusCode === 200) {
          this.promotionsList = [];
          const promotionsData = data.data.records;
          this.totalSize = data.data.count;
          promotionsData.forEach((promotionData: any) => {
            const promotionInstance = new Promotion(promotionData);
            this.promotionsList.push(promotionInstance);
          });
          if (promotionsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, isUsed: this.isUsed};
            this.router.navigate(['/promotions'], { queryParams: this.queryParams });
          }
        }
      });
    }
  }


  exportPromotions(fileTypeId: number) {
    this.exportService.exportFile('promotionCode/export/AllPromotionCodes', fileTypeId, this.searchValue, 'promotionCodes', { isUsed: this.isUsed } );
  }
}
